export const UNKNOWN_DEVICE = Object.freeze({})
